import React, { useState } from "react";
import "./Talk_To_Us.css";
import Common_Btn from "../../common/common-btn/Common_Btn";
import Demo_Modal from "../../common/demo-modal/Demo_Modal";

const Talk_To_Us = () => {
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return (
    <section className="Talk_To_Us">
      <div className="conteiner">
        <div className="talk_us_content_holder">
          <p className="talk_title">
            Talk to us for <span>Pricing</span>
          </p>

          <div className="talk_us_text_holder">
            <div className="talk_us_text_div">
              <p className="talk_us_text">
                Get personalized pricing & feature guidance tailored to your
                needs. Speak directly with our expert & find the best solution
                for you.
              </p>
            </div>

            <div className="btn_holder">
              <Common_Btn text="Get Pricing Details" onClick={handleOpenModal}/>
            </div>
          </div>
        </div>
      </div>

      <Demo_Modal show={showModal} handleClose={handleCloseModal} />
    </section>
  );
};

export default Talk_To_Us;
